import { useContext } from 'react'
import { useLocation, useParams } from 'react-router'
import QuestionTeacher from './QuestionTeacher'
import Question from './Question'
import Main from './Main'
import { AuthContext } from '../context'

const QuestionPage = () => {
  const { setStudentId, setIsAuthStudent } = useContext(AuthContext)
  const params = useParams()
  const qNumber = params.number

  const location = useLocation()
  const questions = location.state.questions
  const disciplineAndTeacher = location.state.disciplineAndTeacher

  if (!(qNumber >= 1 && qNumber <= questions.length)) {
    setIsAuthStudent(false)
    setStudentId(null)
    sessionStorage.removeItem("isAuthStudent")
    sessionStorage.removeItem("studentId")
  }

  return (
    qNumber == 1 ? <QuestionTeacher questions={questions} /> : (qNumber > 1 && qNumber <= questions.length) ? <Question questions={questions} disciplineAndTeacher={disciplineAndTeacher}/> : <Main />
  )
}

export default QuestionPage